export const SKILL_PAGE_CONTENT_LIMIT = 7;
